import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { baseUrl } from '../Univ.js';

function IndentExpiryList() {

  const [pharmviewData, setpharmviewData] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const today = new Date();

  useEffect(() => {
    fetchpharmviewData();
  }, []);

  function fetchpharmviewData() {
    setIsLoading(true);

    axios.get(`${baseUrl}indent-pharm-search/?qty=gt0`)
      .then(response => {
        setpharmviewData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

  const handleStartDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setStartDate(localDate);
  };

  const handleEndDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setEndDate(localDate);
  };

  // 🔥 Filter based on expiry range
  useEffect(() => {
    if (pharmviewData.length > 0) {

        const today = new Date();

        const updatedRows = pharmviewData.map((item) => {
        
          let daysToExpire = '';
        
          if (item.product.expiry) {
            const [day, month, year] = item.product.expiry.split("-");
            const expiryDate = new Date(`${year}-${month}-${day}`);
        
            const diffTime = expiryDate - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
            daysToExpire = diffDays;
          }
        
          return {
            ...item,
            product: item.product.product,
            batch: item.product.batch,
            schedule: item.product.schedule,
            hsn: item.product.hsn,
            type: item.product.type,
            pack: item.product.pack,
            expiry: item.product.expiry,
            mrp: item.product.mrp,
            pprice: item.product.pprice,
            daysToExpire: daysToExpire, // ✅ NEW FIELD
          };
        });

      if (!startDate || !endDate) {
        setRows([]); // 🚫 No data until dates selected
        return;
      }
      
      const filteredRows = updatedRows.filter(item => {
        if (!item.expiry) return false;
      
        const [day, month, year] = item.expiry.split("-");
        const expiryDate = new Date(`${year}-${month}-${day}`);
      
        return expiryDate >= startDate && expiryDate <= endDate;
      });
      
      setRows(filteredRows);
    }
  }, [pharmviewData, startDate, endDate]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 60 },
    { field: 'dept', headerName: 'Raised to', width: 110 },
    { field: 'product', headerName: 'Product', width: 250 },
    { field: 'schedule', headerName: 'Schedule', width: 120 },
    { field: 'batch', headerName: 'Batch', width: 120 },
    { field: 'pack', headerName: 'Pack', width: 60 },
    { field: 'qty', headerName: 'Qty', width: 60 },
    { field: 'expiry', headerName: 'Expiry', width: 110 },
    {
        field: 'daysToExpire',
        headerName: 'Days Left',
        width: 140,
        renderCell: (params) => {
          const val = params.value;
      
          let style = {
            padding: '4px 8px',
            borderRadius: '6px',
            fontWeight: 'bold',
            display: 'inline-block',
            minWidth: '90px',
            textAlign: 'center'
          };
      
          if (val < 0) {
            style.backgroundColor = '#ff4d4f'; // red
            style.color = '#fff';
            return <span style={style}>Expired ({Math.abs(val)}d)</span>;
          } 
          else if (val <= 7) {
            style.backgroundColor = '#ff7875'; // dark red
            style.color = '#fff';
            return <span style={style}>{val} days</span>;
          } 
          else if (val <= 30) {
            style.backgroundColor = '#ffa940'; // orange
            style.color = '#000';
            return <span style={style}>{val} days</span>;
          } 
          else if (val <= 90) {
            style.backgroundColor = '#ffe58f'; // yellow
            style.color = '#000';
            return <span style={style}>{val} days</span>;
          } 
          else {
            style.backgroundColor = '#d9f7be'; // green
            style.color = '#000';
            return <span style={style}>{val} days</span>;
          }
        }
      },
    { field: 'mrp', headerName: 'MRP', width: 80 },
    { field: 'pprice', headerName: 'Pur.Price', width: 90 },

  ];

  return (
    <section className="container mt-4">
      <div className="row">

        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          📅 Indent Expiry List
        </h3>

        {/* ✅ DATE FILTER */}
        <div className="row mt-3 mb-3">
          <div className="col-md-4">
            <label className="control-label">Select Expiry Date Range</label>

            <DatePicker
              selected={startDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              placeholderText="From Date"
              dateFormat="dd/MM/yyyy"
              className="form-control mb-2"
              showMonthDropdown
              showYearDropdown
            />

            <DatePicker
              selected={endDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              
              placeholderText="To Date"
              dateFormat="dd/MM/yyyy"
              className="form-control"
              showMonthDropdown
              showYearDropdown
            />
          </div>
        </div>

        {/* ✅ TABLE */}
        {!isLoading ? (
          startDate && endDate ? (
            rows.length > 0 ? (
            <div style={{ height: '100%', width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={rows}
                columns={columns}
                pageSize={10}
                slots={{ toolbar: GridToolbar }}
                autoHeight
              />
            </div>
          ) : (
            <h5 className="text-center mt-4">No data in selected expiry range</h5>
          )
        ) : (
            <h5 className="text-center mt-4">
              Please select date range to view data
            </h5>
          )
        ) : (
          <>Loading please wait...</>
        )}

      </div>
    </section>
  );
}

export default IndentExpiryList;